import { FeatureInterface, MinesDataInterface } from "../pages/home";
import { MapStyle } from "../types/mapTypes";
import { MAP_STYLE } from "../constants/localStorageConstants";
import { VIEWED_MINES } from "../constants/sessionStorageConstants";

interface Bounds {
  southWest: {
    lat: number;
    lng: number;
  };
  northEast: {
    lat: number;
    lng: number;
  };
}
export const getBounds = (data: MinesDataInterface) => {
  /*
    use only one first point for faster calculation.
    
    To avoid cropping the polygons on the map at the end to the final bounds,
    we simply add a few degrees to minimize the error.
  */

  let result: Bounds | undefined;
  data.features.forEach((feature) => {
    const point = feature.geometry.coordinates.flat(4);
    if (!point) {
      return;
    }

    const [lat, lng] = point;

    if (!result) {
      result = {
        southWest: {
          lat,
          lng,
        },
        northEast: {
          lat,
          lng,
        },
      };
      return;
    }

    if (result.southWest.lat > lat && result.southWest.lng > lng) {
      result.southWest = {
        lat,
        lng,
      };
    }

    if (result.northEast.lat < lat && result.northEast.lng < lng) {
      result.northEast = {
        lat,
        lng,
      };
    }
  });
  if (result) {
    result.southWest.lng -= 0.05;
    result.southWest.lat -= 0.05;

    result.northEast.lng += 0.05;
    result.northEast.lat += 0.05;
  }
  return result;
};

export const getMapStyle = (): MapStyle => {
  // @ts-ignore
  const storedMapStyle: MapStyle | null = localStorage.getItem(MAP_STYLE);
  const validMapStyles: MapStyle[] = ["normal", "satellite"];

  // @ts-ignore
  return validMapStyles.includes(storedMapStyle) ? storedMapStyle : "normal";
};

export const changeStoredMapStyle = (mapStyle: MapStyle) => {
  localStorage.setItem(MAP_STYLE, mapStyle);
};

export const prepareMinesData = (data: MinesDataInterface): MinesDataInterface => {
  const featuresWithoutDuplicates: Record<string, FeatureInterface> = {};
  data.features.forEach((feature) => {
    featuresWithoutDuplicates[JSON.stringify(feature.geometry)] = feature;
  });

  return {
    ...data,
    features: Object.values(featuresWithoutDuplicates),
  };
};

export const addMineToViewed = (id: string | null) => {
  if (!id) {
    return;
  }
  const viewedMines = sessionStorage.getItem(VIEWED_MINES) || "";

  const minesIds = viewedMines.split(",");
  minesIds.push(id);

  sessionStorage.setItem(VIEWED_MINES, minesIds.join(","));
};

export const getViewedMines = () => {
  const viewedMines = sessionStorage.getItem(VIEWED_MINES) || "";

  return viewedMines.split(",").filter((id) => id !== "");
};
